<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a href=/documents/contracts>Список договоров</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать договор</li>
        </ol>
    </nav>

    <form class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Выберите клиента</div>
            <select @change="onChangeClient($event)"
                    v-model="forms.client.selected"
                    class="form-select">
                <option v-for="(item, key) in forms.client.items" v-bind:value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Выберите организацию</div>
            <select :disabled="!forms.client.selected"
                    @change="onChangeOrg($event)"
                    v-model="forms.organization.selected"
                    class="form-select">
                <option v-for="(item, key) in forms.organization.items" v-bind:value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Введите название</div>
            <input
                v-model="forms.data.name"
                type="text"
                class="form-control"
                placeholder="Введите название договора"
            >
        </div>

        <div class="mb-4">
            <div class="form-label">Введите номер</div>
            <input
                v-model="forms.data.number"
                type="text"
                class="form-control"
                placeholder="Введите номер договора"
            >
        </div>

        <div class="mb-4">
            <div class="form-label">Дата начала действия</div>
            <!--            <VueDatePicker v-model="date" locale="ru" :action-row="{ showSelect: false, showCancel: false }"-->
            <!--              :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"-->
            <!--              :format="dateFormat" :teleport="true">-->
            <!--              <template #input-icon>-->
            <!--                <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"-->
            <!--                  xmlns="http://www.w3.org/2000/svg">-->
            <!--                  <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"-->
            <!--                    d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />-->
            <!--                </svg>-->
            <!--              </template>-->
            <!--            </VueDatePicker>-->
            <input
                type="date"
                class="form-control mb-3"
                v-model="forms.data.date"
                placeholder="Введите дату начала действия договора"
            >
        </div>

        <div class="mb-4">
            <div class="form-label">Файл</div>
            <a v-bind:href="this.domain + 'documents/' + forms.data.file" target="blank">{{ forms.data.name }}</a>
        </div>

        <div class="mb-4">
            <div class="form-label">Заменить файл</div>
            <input
                accept="application/pdf"
                ref="contractFile"
                @change="onChangeFile($event)"
                type="file"
                class="form-control mb-3"
            >
        </div>
    </form>

    <div class="col-md-4">
        <div class="d-flex align-items-stretch py-3">
            <button @click="create" type="button" class="btn btn-md btn-primary flex-grow-1 me-3">Сохранить</button>
            <a href="/documents/contracts" type="button" class="btn btn-md btn-outline-dark flex-grow-1">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import { dateFormat } from '../../../../utilites';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContractEditComponent",
    components: { Alert },
    props: {
        item_id: {
            type: [Number, String],
            default: 0
        },
        domain: {
            type: [String],
        }
    },
    data() {
        return {
            forms: {
                client: {
                    selected: null,
                    items: [

                    ]
                },
                organization: {
                    selected: null,
                    items: [

                    ]
                },
                data: {
                    name: null,
                    date: null,
                    number: null,
                    file: null,
                },
                file: {
                    selected: null
                }
            },
            date: null,
            client: null,
            organization: {
                id: null
            },
            contract: null,
            clients: [
                {
                    id: null,
                    name: null
                }
            ],
            organizations: [
                {
                    id: null,
                    name: null
                }
            ],
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        dateFormat,
        getItem: async function () {
            let resp = await axios.get('/documents/contracts/get', {params: {
                    id: this.item_id,
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить договор, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.client.selected = resp.data.item.client_id
                this.forms.organization.selected = resp.data.item.organization_id;
                this.forms.data.name = resp.data.item.name;
                this.forms.data.number = resp.data.item.number;
                this.forms.data.date = resp.data.item.date;
                this.forms.data.file = resp.data.item.path;

                this.listOrgs();
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        listClients: async function () {
            let response = await axios.get('/organizational/client/list', {params: {
                    page: 1,
                    limit: 100
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список клиентов, что-то пошло не так' });
            });

            if (response.data.status === 'ok') {
                this.forms.client.items = response.data.items;
            }

            if (response.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        listOrgs: async function () {
            let response = await axios.get('/organizational/organizations/list', {params: {
                    page: 1,
                    limit: 100,
                    client_id: this.forms.client.selected
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что-то пошло не так' });
            });

            if (response.data.status === 'ok') {
                this.forms.organization.items = response.data.items;
            }

            if (response.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
            }
        },
        onChangeClient: async function (e) {
            this.forms.client.selected = e.target.value;
            this.listOrgs();
        },
        onChangeOrg: function () {

        },
        onChangeFile: function (e) {
            if (!e.target.files[0] || e.target.files[0].type !== 'application/pdf') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Только файлы с расширением pdf' });
                e.target.value = null;
            }

            if (e.target.files[0] && e.target.files[0].type === 'application/pdf') {
                this.forms.file.selected = e.target.files[0];
            }
        },
        create: async function() {
            if (!this.forms.client.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента' });
                return;
            }

            if (!this.forms.organization.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите организацию' });
                return;
            }

            if (!this.forms.data.name) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название документа' });
                return;
            }

            if (!this.forms.data.number) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите номер документ' });
                return;
            }

            if (!this.forms.data.date) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите дату документа' });
                return;
            }

            const formData = new FormData();

            formData.append('id', this.item_id);
            formData.append('client_id', this.forms.client.selected);
            formData.append('org_id', this.forms.organization.selected);
            formData.append('name', this.forms.data.name);
            formData.append('number', this.forms.data.number);
            formData.append('date', this.forms.data.date);

            if (this.forms.file.selected) {
                formData.append('file', this.forms.file.selected);
            }

            const resp = await axios.post('/documents/contracts/edit/contract', formData).catch(res => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось отредактировать договор, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Договор успешно отредактирован' });
                window.location.reload();
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
    },
    async mounted() {
        this.getItem();
        this.listClients();
    }
};
</script>
<style scoped></style>
